import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EMessageType;
(function (EMessageType) {
  EMessageType["Inbound"] = "inbound";
  EMessageType["Outbound"] = "outbound";
})(EMessageType || (EMessageType = {}));
export let EMessageStatus;
(function (EMessageStatus) {
  EMessageStatus["Sent"] = "sent";
  EMessageStatus["Pending"] = "pending";
  EMessageStatus["Delivered"] = "delivered";
  EMessageStatus["Undelivered"] = "undelivered";
  EMessageStatus["Opened"] = "opened";
  EMessageStatus["Skipped"] = "skipped";
})(EMessageStatus || (EMessageStatus = {}));
export let EMessageChannel;
(function (EMessageChannel) {
  EMessageChannel["Sms"] = "sms";
  EMessageChannel["Email"] = "email";
  EMessageChannel["Voice"] = "voice";
  EMessageChannel["Inapp"] = "inapp";
  EMessageChannel["Chat"] = "chat";
  EMessageChannel["Fax"] = "fax";
  EMessageChannel["Whatsapp"] = "whatsapp";
})(EMessageChannel || (EMessageChannel = {}));
export let EMessageClassification;
(function (EMessageClassification) {
  EMessageClassification["Positive"] = "positive";
  EMessageClassification["Negative"] = "negative";
  EMessageClassification["Irregular"] = "irregular";
  EMessageClassification["RecognizedKeywords"] = "recognized-keywords";
  EMessageClassification["Unclassified"] = "unclassified";
})(EMessageClassification || (EMessageClassification = {}));
export let EMessageVisibility;
(function (EMessageVisibility) {
  EMessageVisibility["Public"] = "public";
  EMessageVisibility["Private"] = "private";
  EMessageVisibility["Internal"] = "internal";
})(EMessageVisibility || (EMessageVisibility = {}));
export let EVoiceAnsweredBy;
(function (EVoiceAnsweredBy) {
  EVoiceAnsweredBy["Human"] = "human";
  EVoiceAnsweredBy["Fax"] = "fax";
  EVoiceAnsweredBy["Unknown"] = "unknown";
  EVoiceAnsweredBy["MachineStart"] = "machine-start";
  EVoiceAnsweredBy["MachineEndBeep"] = "machine-end-beep";
  EVoiceAnsweredBy["MachineEndSilence"] = "machine-end-silence";
  EVoiceAnsweredBy["MachineEndOther"] = "machine-end-other";
})(EVoiceAnsweredBy || (EVoiceAnsweredBy = {}));
export let EMessageSource;
(function (EMessageSource) {
  EMessageSource["Hub"] = "hub";
  EMessageSource["PatientProfile"] = "patientProfile";
})(EMessageSource || (EMessageSource = {}));
export let EMessageExternalSource;
(function (EMessageExternalSource) {
  EMessageExternalSource["Mandrill"] = "mandrill";
  EMessageExternalSource["Twilio"] = "twilio";
  EMessageExternalSource["Nexmo"] = "nexmo";
  EMessageExternalSource["Sendgrid"] = "sendgrid";
  EMessageExternalSource["Plivo"] = "plivo";
  EMessageExternalSource["Bandwidth"] = "bandwidth";
  EMessageExternalSource["RingCentral"] = "ringcentral";
  EMessageExternalSource["AWSSES"] = "awsses";
  EMessageExternalSource["Interfax"] = "interfax";
})(EMessageExternalSource || (EMessageExternalSource = {}));
export let EMessageRecipientType;
(function (EMessageRecipientType) {
  EMessageRecipientType["Doctor"] = "doctor";
  EMessageRecipientType["Staff"] = "staff";
  EMessageRecipientType["Patient"] = "patient";
})(EMessageRecipientType || (EMessageRecipientType = {}));
export let EMessageMentionType;
(function (EMessageMentionType) {
  EMessageMentionType["User"] = "user";
  EMessageMentionType["Group"] = "group";
})(EMessageMentionType || (EMessageMentionType = {}));
export let EMessageKey; // TODO danielmana figure out if there are more possible values for `IMessage.key`
(function (EMessageKey) {
  EMessageKey["InteractiveVoiceResponse"] = "interactiveVoiceResponse";
  EMessageKey["InteractiveVoiceResponseDeflection"] = "interactiveVoiceResponseDeflection";
  EMessageKey["PatientReminder"] = "patientReminder";
  EMessageKey["PatientReminderConfirmationOnly"] = "patientReminderConfirmationOnly";
  EMessageKey["PatientApptOffer"] = "patientApptOffer";
  EMessageKey["PatientApptOfferWithReschedule"] = "patientApptOfferWithReschedule";
  EMessageKey["PatientReferralReminder"] = "patientReferralReminder";
  EMessageKey["PatientReferralLastReminder"] = "patientReferralLastReminder";
  EMessageKey["PatientOutreachReminder"] = "patientOutreachReminder";
  EMessageKey["PatientOutreachLastReminder"] = "patientOutreachLastReminder";
  EMessageKey["PatientOutboundReferralReminder"] = "patientOutboundReferralReminder";
})(EMessageKey || (EMessageKey = {}));
export const fieldsMessage = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  automated: {
    type: 'Boolean'
  },
  channel: {
    type: 'Option',
    values: EMessageChannel
  },
  classification: {
    type: 'Option',
    values: EMessageClassification
  },
  externalId: {
    type: 'Object'
  },
  externalStatus: {
    type: 'Object'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  file: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  followup: {
    type: 'ID',
    ref: EModel.Followup
  },
  from: {
    type: 'Text'
  },
  key: {
    type: 'Text'
  },
  language: {
    type: 'Text'
  },
  media: {
    type: 'Object'
  },
  mentions: {
    type: 'Object',
    array: true
  },
  messageFailure: {
    type: 'ID',
    ref: EModel.MessageFailure
  },
  notifyTo: {
    type: 'Object',
    array: true
  },
  outboundMessage: {
    type: 'ID',
    ref: EModel.Message
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientMessageTemplate: {
    type: 'ID',
    ref: EModel.PatientMessageTemplate
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  recall: {
    type: 'ID',
    ref: EModel.Recall
  },
  recipient: {
    type: 'ID',
    ref: EModel.User
  },
  recipientType: {
    type: 'Option',
    values: EMessageRecipientType
  },
  ref: {
    type: 'Text'
  },
  referral: {
    type: 'ID',
    ref: EModel.Referral
  },
  refId: {
    type: 'Text'
  },
  retry: {
    type: 'Object'
  },
  searchIds: {
    type: 'Text',
    array: true
  },
  secure: {
    type: 'Boolean'
  },
  shouldForceContactWithNotifyTo: {
    type: 'Boolean'
  },
  skippedStatusReason: {
    type: 'Text'
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: EMessageStatus
  },
  statusReason: {
    type: 'Text'
  },
  terminatingStateAt: {
    type: 'Date'
  },
  text: {
    type: 'Text'
  },
  to: {
    type: 'Text'
  },
  type: {
    type: 'Option',
    values: EMessageType
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  visibility: {
    type: 'Option',
    values: EMessageVisibility
  },
  voiceAnsweredBy: {
    type: 'Option',
    values: EVoiceAnsweredBy
  }
});